// eslint-disable-next-line caprikorn-rules/use-custom-translations
import { Trans } from "react-i18next";

import { CustomTranslation } from "@utils/translations/CustomTranslation/CustomTranslation";
import { useCustomTranslationContext } from "@utils/translations/CustomTranslation/CustomTranslation.context";

// TODO force i18nKey & ns mandatory & string only
export const CustomTrans: typeof Trans =
  import.meta.env.VITE_APP_EDIT_TRANSLATION !== "true"
    ? Trans
    : (props) => {
        useCustomTranslationContext();

        return (
          <CustomTranslation
            ns={props.ns as never}
            translationKey={props.i18nKey as never}
          >
            <Trans {...props} />
          </CustomTranslation>
        );
      };
